import { render } from "./Intro.vue?vue&type=template&id=5be17a40&scoped=true&lang=pug"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=5be17a40&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be17a40"]])

export default __exports__